export default __webpack_public_path__ + "static/media/elb.72853c25.svg";